import React from "react";
import { Menu, Dropdown, Icon, Layout } from "antd";
import { withRouter, Link } from "react-router-dom";
import LanguageChangingDropdown from "../LanguageChangingDropdown";
import { connect } from "react-redux";
import { clear } from "idb-keyval";
import { MdLanguage } from "react-icons/md";
const { Header } = Layout;

class InjazHeader extends React.Component {
  state = {
    collapsed: true,
    shouldHide: true,
  };

  handleLogout() {
    let newObj = { ...JSON.parse(localStorage.getItem("persist:root")) };
    newObj.user = {};
    newObj.clientById = {};
    newObj.parametersListByParaType = {};
    localStorage.clear();
    try {
      clear();
    } catch {}
    this.props.history.push("/");
    window.location.reload();
  }

  render() {
    const { handleToggle } = this.props;
    const menu = (
      <Menu className="top-header">
        <Menu.Item>
          {localStorage.getItem("darkTheme") ? (
            localStorage.getItem("darkTheme") == "true" ? (
              <button
                className="link-button black-text-color"
                onClick={() => {
                  localStorage.setItem("darkTheme", false);
                  window.location.reload();
                }}
                rel="noopener noreferrer"
              >
                <Icon
                  type="bg-colors"
                  theme="outlined"
                  className="dropdown-icon link-button black-text-color  "
                />
                Light Theme
              </button>
            ) : (
              <button
                className="link-button black-text-color"
                onClick={() => {
                  localStorage.setItem("darkTheme", true);
                  window.location.reload();
                }}
                rel="noopener noreferrer"
              >
                <Icon
                  type="bg-colors"
                  theme="outlined"
                  className="dropdown-icon link-button black-text-color "
                />
                Dark Theme
              </button>
            )
          ) : (
            <button
              className="link-button black-text-color"
              onClick={() => {
                localStorage.setItem("darkTheme", true);
                window.location.reload();
              }}
              rel="noopener noreferrer"
            >
              <Icon
                type="bg-colors"
                theme="outlined"
                className="dropdown-icon link-button black-text-color "
              />
              Dark Theme
            </button>
          )}
        </Menu.Item>
        <Menu.Item onClick={this.handleLogout.bind(this)}>
          <button
            className="link-button  black-text-color"
            rel="noopener noreferrer"
          >
            <MdLanguage size={20} />
            Switch Language
          </button>
        </Menu.Item>
        <Menu.Item onClick={this.handleLogout.bind(this)}>
          <button
            className="link-button black-text-color"
            rel="noopener noreferrer"
          >
            <Icon
              type="logout"
              theme="outlined"
              className="dropdown-icon  link-button black-text-color "
            />
            Logout
          </button>
        </Menu.Item>
      </Menu>
    );

    return (
      <Header className="header-styling sticky">
        {!this.props.posProps && (
          <Icon
            className="trigger"
            type={this.props.collapsed ? "menu-unfold" : "menu-fold"}
            onClick={handleToggle}
          />
        )}
        <div className="header-links" style={{ float: "right" }}>
          {/* <Dropdown overlay={menu}>
            <button className="ant-dropdown-link link-button  " style={{ marginRight: 10 }}>
              <Icon type="down" /><span></span>
              {this.props.userName.toUpperCase()}
            </button>
          </Dropdown> */}

          <LanguageChangingDropdown />
        </div>
      </Header>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userName: state.user.name,
  };
};
export default connect(mapStateToProps)(withRouter(InjazHeader));
